'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tooltipKey", "tooltipOptions", "showEnableLang"];
import I18n from 'I18n';
import PropTypes from 'prop-types';
import BasePermissionTooltip from 'customer-data-ui-utilities/tooltips/permission/BasePermissionTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const PermissionTooltip = props => {
  const {
      tooltipKey,
      tooltipOptions,
      showEnableLang
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const title = I18n.text(`customerDataObjectsUiComponents.Permissions.${tooltipKey}`, tooltipOptions);
  return /*#__PURE__*/_jsx(BasePermissionTooltip, Object.assign({}, rest, {
    title: title,
    showCta: showEnableLang,
    children: props.children
  }));
};
PermissionTooltip.propTypes = {
  tooltipKey: PropTypes.string.isRequired,
  tooltipOptions: PropTypes.object,
  showEnableLang: PropTypes.bool,
  children: PropTypes.node
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
PermissionTooltip.defaultProps = {
  tooltipKey: 'generic.unknown',
  tooltipOptions: {},
  showEnableLang: true
};
export default PermissionTooltip;